<div class="p-col-12 p-lg-12 mb30">
  @if (isLoading) {
    <div class="loading-indicator">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }

  <p-tabs scrollable value="0">
    <p-tablist>
      <p-tab value="0">All Events</p-tab>
      <p-tab value="1">All Events Milestone 2</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <div class="p-col-12 p-lg-12 pageheader">
          <div class="fl-right">
            <button
              type="button"
              pButton
              (click)="exportNoPayeeIDPaymentReport()"
              class="ui-button-primary excel-export">
              <span
                >No Payee ID <br />
                Ready for Payment Report
              </span>
            </button>
          </div>
          <div class="fl-right export-btn-first">
            <button
              type="button"
              pButton
              (click)="exportReadyforPaymentReport()"
              class="ui-button-primary excel-export btn-excel-first">
              <span>Ready for Payment Report </span>
            </button>
          </div>
        </div>

        <div class="ui-g card">
          <div class="ui-g-12 ui-md-12 ui-lg-12 tbst">
            <p-table
              #pa
              [columns]="cols"
              [scrollable]="true"
              [style]="{ width: '100%' }"
              [value]="downloadCSVList"
              selectionMode="single"
              [loadingIcon]="loadingIcon"
              [showLoader]="true"
              [(selection)]="selectedItem"
              [rowsPerPageOptions]="[24]"
              [paginator]="true"
              [rows]="24"
              paginatorPosition="both">
              <ng-template #header>
                <tr>
                  <th
                    [pSortableColumn]="'fileName'"
                    class="collarge"
                    style="width: 200px">
                    File Name <p-sortIcon [field]="'fileName'"></p-sortIcon>
                  </th>
                  <th
                    [pSortableColumn]="'createdOn'"
                    class="collarge"
                    style="width: 200px">
                    File Created on (PST)
                    <p-sortIcon [field]="'createdOn'"></p-sortIcon>
                  </th>
                  <th class="colsmall" style="text-align: center">
                    Download CSV
                  </th>
                </tr>
                <tr></tr
              ></ng-template>
              <ng-template #body let-downloadCSVList let-columns="columns">
                <tr>
                  <td class="collarge" style="width: 200px">
                    {{ downloadCSVList.fileName }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ downloadCSVList.createdOn }}
                  </td>
                  <td class="colsmall text-center">
                    <button
                      (click)="downloadFile(downloadCSVList)"
                      tooltipPosition="top"
                      pTooltip="{{ downloadCSVList.fileName }}"
                      class="edit-button-link">
                      <i
                        class="fa fa-file-excel-o"
                        aria-hidden="true"
                        style="font-size: 16px"></i>
                    </button>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-tabpanel>
      <p-tabpanel value="1">
        <div class="p-col-12 p-lg-12 pageheader">
          <div class="fl-right export-btn-first">
            <button
              type="button"
              pButton
              (click)="exportAllEventMilestone2()"
              class="ui-button-primary excel-export btn-excel-first">
              <span>Export All Event Milestone 2</span>
            </button>
          </div>
        </div>
        <div class="ui-g card">
          <div class="ui-g-12 ui-md-12 ui-lg-12 tbst">
            <p-table
              #dt
              [columns]="m2Cols"
              [scrollable]="true"
              [style]="{ width: '100%' }"
              [value]="alleventsmilestone2Data"
              [loadingIcon]="loadingIcon"
              [showLoader]="true"
              [loading]="isLoading"
              [rows]="24"
              paginatorPosition="both"
              [paginator]="true"
              exportFilename="alleventsmilestone2">
              <ng-template #header>
                <tr>
                  <th class="collarge" style="width: 200px">
                    EventRegistrationID
                  </th>
                  <th class="collarge" style="width: 200px">Event Key</th>
                  <th class="collarge" style="width: 200px">Event Name</th>
                  <th class="collarge" style="width: 200px">Category Name</th>
                  <th class="collarge" style="width: 200px">Customer Name</th>
                  <th class="collarge" style="width: 200px">TenantId</th>
                  <th class="collarge" style="width: 200px">
                    PartnerInputCustomerName
                  </th>
                  <th class="collarge" style="width: 200px">
                    PartnerInputValidationDetails
                  </th>
                  <th class="collarge" style="width: 200px">
                    PartnerInputValidationType
                  </th>
                  <th class="collarge" style="width: 200px">RequestDate</th>
                  <th class="collarge" style="width: 200px">FiscalYear</th>
                  <th class="collarge" style="width: 200px">
                    DateSubmittedPST
                  </th>
                  <th class="collarge" style="width: 200px">EventStatus</th>
                  <th class="collarge" style="width: 200px">PartnerOneId</th>
                  <th class="collarge" style="width: 200px">PartnerLocation</th>
                  <th class="collarge" style="width: 200px">
                    PMO Confirmed PartnerID
                  </th>
                  <th class="collarge" style="width: 200px">
                    PMO Confirmed Partner Name
                  </th>
                  <th class="collarge" style="width: 200px">Payee ID</th>
                  <th class="collarge" style="width: 200px">Payee Name</th>
                  <th class="collarge" style="width: 200px">Submitted Date</th>
                  <th class="collarge" style="width: 200px">
                    L1 Internal Status Name
                  </th>
                  <th class="collarge" style="width: 200px">
                    Workshop Completion Date
                  </th>
                  <th class="collarge" style="width: 200px">
                    POE Completion Date
                  </th>
                  <th class="collarge" style="width: 200px">
                    Event Poe StatusName
                  </th>
                  <th class="collarge" style="width: 200px">
                    Event Completion Date
                  </th>
                  <th class="collarge" style="width: 200px">
                    Scheduled EventDate
                  </th>
                  <th class="collarge" style="width: 200px">
                    Incentive Status
                  </th>
                  <th class="collarge" style="width: 200px">PaymentType</th>
                  <th class="collarge" style="width: 200px">
                    Tier1 PaymentAmount
                  </th>
                  <th class="collarge" style="width: 200px">Tier1 MetDate</th>
                  <th class="collarge" style="width: 200px">Tier1 PaidDate</th>
                  <th class="collarge" style="width: 200px">
                    Tier1 MaturityDate
                  </th>
                  <th class="collarge" style="width: 200px">
                    Tier1 MaturityStatus
                  </th>
                  <th class="collarge" style="width: 200px">Tier1 Target</th>
                  <th class="collarge" style="width: 200px">
                    Tier1 MSInvoiceNumber
                  </th>
                  <th class="collarge" style="width: 200px">
                    Tier1 MSInvoiceDate
                  </th>
                  <th class="collarge" style="width: 200px">
                    Tier1 PaymentCentral TransactionID
                  </th>
                  <th class="collarge" style="width: 200px">
                    Tier1 PaymentDocumentNumber
                  </th>
                  <th class="collarge" style="width: 200px">
                    Tier2 PaymentAmount
                  </th>
                  <th class="collarge" style="width: 200px">Tier2 MetDate</th>
                  <th class="collarge" style="width: 200px">Tier2 PaidDate</th>
                  <th class="collarge" style="width: 200px">
                    Tier2 MaturityDate
                  </th>
                  <th class="collarge" style="width: 200px">
                    Tier2 MaturityStatus
                  </th>
                  <th class="collarge" style="width: 200px">Tier2 Target</th>
                  <th class="collarge" style="width: 200px">
                    Tier2 MSInvoiceNumber
                  </th>
                  <th class="collarge" style="width: 200px">
                    Tier2 MSInvoiceDate
                  </th>
                  <th class="collarge" style="width: 200px">
                    Tier2 PaymentCentral TransactionID
                  </th>
                  <th class="collarge" style="width: 200px">
                    Tier2 Payment DocumentNumber
                  </th>
                </tr>
              </ng-template>
              <ng-template
                #body
                let-alleventsmilestone2Data
                let-columns="columns">
                <tr>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.eventRegistrationID }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.eventKey }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.eventName }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.categoryName }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.customerName }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.tenantId }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.partnerInputCustomerName }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.partnerInputValidationDetails }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.partnerInputValidationType }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.requestDate }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.fiscalYear }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.dateSubmittedPST }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.eventStatus }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.partnerOneId }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.partnerLocation }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.pmoConfirmedPartnerID }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.pmoConfirmedPartnerName }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.payeeID }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.payeeName }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.submittedDate }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.l1InternalStatusName }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.workshopCompletionDate }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.poeCompletionDate }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.eventPoeStatusName }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.eventCompletionDate }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.scheduledEventDate }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.incentiveStatus }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.paymentType }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.tier1PaymentAmount }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.tier1MetDate }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.tier1PaidDate }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.tier1MaturityDate }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.tier1MaturityStatus }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.tier1Target }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.tier1MSInvoiceNumber }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.tier1MSInvoiceDate }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{
                      alleventsmilestone2Data.tier1PaymentCentralTransactionID
                    }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.tier1PaymentDocumentNumber }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.tier2PaymentAmount }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.tier2MetDate }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.tier2PaidDate }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.tier2MaturityDate }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.tier2MaturityStatus }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.tier2Target }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.tier2MSInvoiceNumber }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.tier2MSInvoiceDate }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{
                      alleventsmilestone2Data.tier2PaymentCentralTransactionID
                    }}
                  </td>
                  <td class="collarge" style="width: 200px">
                    {{ alleventsmilestone2Data.tier2PaymentDocumentNumber }}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
